import React from 'react'

import ImportInvoices from '../../components/import_invoices'

export default function ImportCommissionsCollectionsInvoices() {
  const companies = [
    {
      label: 'Paycomet',
      value: 'pyco',
    },
    {
      label: 'Caixa Banc',
      value: 'cxbn',
    },
    {
      label: 'Stripe',
      value: 'strp',
    },
    {
      label: 'Paypal',
      value: 'payp',
    },
    {
      label: 'Adyen',
      value: 'adyn',
    },
  ]

  const templateImport = 'commissions'

  const props = {
    companies: companies,
    template: templateImport,
    labelTemplate: 'Select the payment gateway provider',
    title: 'Import commissions collections',
  }
  return (
    <>
      <ImportInvoices props={props} />
    </>
  )
}
